<template>
  <div class="row p-3">
    <div class="col-12 p-0">
      <div class="row p-0 d-flex justify-content-between align-items-center">
        <!-- جستجوی پیشرفته در لیست حساب ها -->
        <div class="col-4 p-0 pb-2">
          <div class="input-group p-0">
            <input id="textDocInfoAllRecordSearch" placeholder="جستجو پیشرفته در لیست حساب‌ها (Enter)" type="text"
              class="form-control form-control-sm rounded-0" v-on:focus="$event.target.select()"
              v-on:keyup.enter="FilterDataInSearch($event.target.value); $event.target.select();" />
            <div class="input-group-prepend rounded-0">
              <span class="
                  input-group-text input-group-box-size
                  bg-secondary
                  rounded-left
                  white-text
                ">
                <a v-on:click="FilterDataInSearch('Search')">
                  <i class="fas fa-search"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div class="col text-right">
          <span>{{ ListSearchOld }}</span>
        </div>
      </div>
    </div>
    <div class="table-responsive position-relative">
      <table class="table table-bordered table-sm text-center table-font-size w-100">
        <thead style="background-color: #f7f7f7; height: 32px;">
          <td :colspan="intPageNumber > 1 ? 2 : 1">
            <a v-on:click="scrollTable('LastAllRecordRow')" title="مشاهده سطر انتهایی">
              <i class="far fa-arrow-alt-circle-down fa-1x-half text-secondary"></i>
            </a>
          </td>
          <td colspan="12">
            تعداد لیست حساب‌های موجود : {{ TbDocInfoAllRecord.length }} مورد
            <!-- انتقال به سطر انتهایی -->
          </td>
        </thead>
        <!-- سربرگ جدول -->
        <thead class="text-light bg-secondary" style="height: 32px;">
          <td :colspan="intPageNumber > 1 ? 2 : 1">ردیف</td>
          <td>شناسه سند</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی سال" v-on:click="sortDocRow('NYear', '')">
              سال
            </a>
          </td> -->
          <td>سال</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی شماره سند" v-on:click="sortDocRow('NDocNu', '')">
              شماره سند
            </a>
          </td> -->
          <td>شماره سند</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی کد حساب" v-on:click="sortDocRow('NAccCode', '')">
              کد حساب
            </a>
          </td> -->
          <td>کد حساب</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی شرح حساب" v-on:click="sortDocRow('SAccDesc', '')">
              شرح حساب
            </a>
          </td> -->
          <td>شرح حساب</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی بدهکار" v-on:click="sortDocRow('NDebit', '')">
              بدهکار
            </a>
          </td> -->
          <td>بدهکار</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی بستانکار" v-on:click="sortDocRow('NCredit', '')">
              بستانکار
            </a>
          </td> -->
          <td>بستانکار</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی طرف حساب" v-on:click="sortDocRow('NPerLastName', '')">
              طرف حساب
            </a>
          </td> -->
          <td>طرف حساب</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی مرکز هزینه" v-on:click="sortDocRow('SDesc', '')">
              مرکز هزینه
            </a>
          </td> -->
          <td>مرکز هزینه</td>
          <td style="
                  max-width: 140px;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                ">مشاهده</td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <template v-for="(row, index) in getListDataPaging">
            <tr :key="row.RowIndex" :class="{ selRow: SelectRowIndex == row.RowIndex }"
              v-on:click="SaveRowSelect(row, row.RowIndex)" v-bind:id="row.RowIndex" style="cursor: pointer">
              <!-- ردیف -->
              <td v-if="intPageNumber > 1" style="
                          max-width: 35px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;
                      ">
                {{ index + 1 }}
              </td>
              <td style="
                          max-width: 50px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;
                      ">
                {{ row.RowID }}
              </td>
              <!-- شناسه سند -->
              <td style="
                          max-width: 120px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;
                      ">
                {{ row.NId }}
              </td>
              <!-- سال -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.NYear }}
              </td>
              <!-- شماره سند -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.NDocNu }}
              </td>
              <!-- کد حساب -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.NAccCode }}
              </td>
              <!-- شرح حساب -->
              <td style="
                  max-width: 200px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
                :title="row.SAccDesc"
              >
                <!-- استفاده از این کامپاننت در تعداد زیاد سرعت لود را پایین می آورد -->
                <!-- <DescriptionByTooltip v-bind:DescritionData="row.SAccDesc" v-bind:showTop="index + 5 < TbDocInfoAllRecord.length ? false : true
                  "></DescriptionByTooltip> -->
                {{ row.SAccDesc }}
              </td>
              <!-- بدهکار -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.NDebit | numFormat }}
              </td>
              <!-- بستانکار -->
              <td style="
                  text-align: right !important;
                  padding-right: 5px !important;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  max-width: 120px;
                ">
                {{ row.NCredit | numFormat }}
              </td>
              <!-- طرف حساب -->
              <td style="
                  max-width: 200px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
                :title="row.NPerName + ' ' + row.NPerLastName"
              >
                <!-- استفاده از این کامپاننت در تعداد زیاد سرعت لود را پایین می آورد -->
                <!-- <DescriptionByTooltip v-bind:DescritionData="row.NPerID + ' ' + row.NPerName + ' ' + row.NPerLastName
                  " v-bind:showTop="index + 5 < TbDocInfoAllRecord.length ? false : true
                "></DescriptionByTooltip> -->
                <span v-if="row.NPerID != 0">
                  {{ row.NPerID + ' ' + row.NPerName + ' ' + row.NPerLastName }}
                </span>
              </td>
              <!-- مرکز هزینه -->
              <td style="
                  max-width: 200px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
                :title="row.SDesc"
              >
                <!-- استفاده از این کامپاننت در تعداد زیاد سرعت لود را پایین می آورد -->
                <!-- <DescriptionByTooltip v-bind:DescritionData="row.NUsePlace + ' ' + row.SDesc" 
                v-bind:showTop="index + 5 < TbDocInfoAllRecord.length ? false : true"></DescriptionByTooltip> -->
                <span v-if="row.NUsePlace != 0">
                  {{ row.NUsePlace + " " + row.SDesc }}
                </span>
              </td>
              <!-- مدیریت -->
              <td style="
                  max-width: 140px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                ">
                <!-- منوی مشاهده اطلاعات سند در زیر همین سطر -->
                <a href="#" title="مشاهده سند" v-on:click="ShowDocRow(index, row.NDocNu, row.NId)">
                  <i v-if="checkShowDocRow != index" class="fas fa-angle-left m-1 text-primary"></i>
                  <i v-else class="fas fa-angle-down m-1 text-primary"></i>
                </a>
              </td>
            </tr>
            <tr v-if="checkShowDocRow == index" :key="'docRows' + index">
              <td colspan="14" style="padding: 5px 15px !important; overflow: unset ; background-color: #f1fdff"
                :style="checkLoadData == true ? 'background-color: #ffffff;' : 'background-color: #f1fdff;'">
                <span v-if="checkLoadData == true"
                  class="d-flex flex-column justify-content-center align-items-center my-2 h10 text-info">
                  <img style="width: 150px; height: 50px" :src="waitImage" alt="لطفا چند لحظه صبر کنید ..." />
                  در حال دریافت اطلاعات ...
                </span>
                <div v-else>
                  <div class="row justify-content-between">
                    <div class="mt-2 mb-1 h9 text-info">
                      اطلاعات سند شماره {{ row.NDocNu }} ( شناسه : {{ row.NId }} )
                    </div>
                  </div>
                  <table class="
                      table table-bordered table-sm
                      text-center
                      table-font-size
                      bg-white
                    ">
                    <!-- سربرگ جدول -->
                    <thead class="text-light bg-info">
                      <td>شناسه سند</td>
                      <td>سال</td>
                      <td>شماره سند</td>
                      <td>تاریخ سند</td>
                      <td>نوع سند</td>
                      <td>شرح سند</td>
                      <td>بدهکار</td>
                      <td>بستانکار</td>
                      <td>وضعیت</td>
                      <td>سازمان</td>
                      <td>مدیریت</td>
                    </thead>
                    <!-- محتویات جدول -->
                    <tbody>
                      <template v-if="docDataForShow.length > 0">
                        <template v-for="item in docDataForShow">
                          <tr :key="item.NId" class="rowBoxShadow">
                            <!-- شناسه سند -->
                            <td class="tdGradient2" rowspan="2">
                              {{ item.NId }}
                            </td>
                            <!-- سال -->
                            <td class="tdGradient">
                              {{ item.NYear }}
                            </td>
                            <!-- شماره سند -->
                            <td class="tdGradient">
                              {{ item.NDocNu }}
                            </td>
                            <!-- تاریخ سند -->
                            <td class="tdGradient">
                              {{ item.SDocDate }}
                            </td>
                            <!-- نوع سند -->
                            <td class="tdGradient">
                              {{ item.SDocType }}
                            </td>
                            <!-- شرح سند -->
                            <td class="tdGradient2" style="max-width: 150px;">
                              <DescriptionByTooltip v-bind:DescritionData="item.SDocDesc" v-bind:showTop="true">
                              </DescriptionByTooltip>
                            </td>
                            <!-- بدهکار -->
                            <td class="tdGradient2">
                              {{ item.NDebit | numFormat }}
                            </td>
                            <!-- بستانکار -->
                            <td class="tdGradient2">
                              {{ item.NCredit | numFormat }}
                            </td>
                            <!-- وضعیت -->
                            <td class="tdGradient2">
                              {{ item.SStatus }}
                            </td>
                            <!-- سازمان -->
                            <td class="tdGradient2" style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                              ">
                              {{ item.SOrgCode }}
                            </td>
                            <!-- مدیریت -->
                            <td style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                padding-left: 5px !important;
                                padding-right: 5px !important;
                            ">
                              <!-- مشاهده سند -->
                              <a href="#" title="مراجعه به سند"
                                v-on:click="showDocInfoData(item.NId, item.NDocNu, item.BStatus)">
                                <i class="fas fa-file-alt fa-lg m-1 text-primary"></i>
                              </a>
                              <!-- کپی از سند -->
                              <a href="#" title="کپی از سند" v-on:click="CopyDocRowToNewDoc(item.NId, item.NDocNu)">
                                <i class="fas fa-copy fa-lg m-1 text-primary"></i>
                              </a>
                            </td>
                          </tr>
                        </template>
                      </template>
                      <template v-else>
                        <tr>
                          <td colspan="11" class="tdGradient2">
                            <h6>عدم مشاهده اطلاعات سند</h6>
                            برای سند شماری {{ row.NDocNu }} ، اطلاعاتی مشاهده نشد !
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot style="background-color: #f7f7f7; height: 32px;" id="LastAllRecordRow">
          <td :colspan="intPageNumber > 1 ? 2 : 1">
            <!-- انتقال به سطر ابتدایی -->
            <a v-on:click="scrollTable('textDocInfoAllRecordSearch')" title="مشاهده سطر ابتدایی">
              <i class="far fa-arrow-alt-circle-up fa-1x-half text-secondary"></i>
            </a>
          </td>
          <td colspan="11">
            <PaginationAllRecord v-bind:Name="'ListAllRecord'" v-bind:CountRow="intCountRow"
              v-bind:DataRepository="TbDocInfoAllRecord" v-on:ChangePage="ChangePageAllRow"></PaginationAllRecord>
          </td>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import DescriptionByTooltip from "../../PublicComponents/DescriptionByTooltip.vue";
import PaginationAllRecord from "../../PublicComponents/Pagination.vue"
import { BusEvent } from "../../../../../main.js";

export default {
  name: "Tab2_listHesab",
  components: {
    DescriptionByTooltip,
    PaginationAllRecord,
  },
  data() {
    return {
      // بررسی زمان دریافت اطلاعات از سرور
      EndGetDataFromServer: false,
      // مربوط به صفحه بندی
      intPageNumber: 1,  // شماره صفحه در حال انتخاب
      intCountRow: 500,   // تعداد سطرها در هر صفحه
      intCountPage: 1,   // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده

      // موارد جستجو شده قبلی
      ListSearchOld: '',

      // لیست محلی تمام رکوردهای تمام سندها
      TbDocInfoAllRecord: [
        {
          RowIndex: 0,  // شماره سطر یکتا
          NYear: 0, // سال
          NDocNu: 0, // شماره سند
          NAccCode: 0, // کد حساب
          SAccDesc: "", // شرح حساب
          NDebit: 0, // بدهکار
          NCredit: 0, // بستانکار
          NPerID: 0, // طرف حساب
          NPerName: "", // نام طرف حساب
          NPerLastName: "", // نام خانوادگی طرف حساب
          NPerType: 0, // نوع طرف حساب
          NUsePlace: 0, // مرکز هزینه
          SDesc: "", // عنوان مرکز هزینه
          SDate: "", // تاریخ
        },
      ],
      // اطلاعات سند در حال نمایش
      docDataForShow: {
        NId: 0, // شناسه سند
        NYear: 0, // سال
        NDocNu: 0, // شماره سند
        SDocDate: "", // تاریخ سند
        NDocType: 0, // نوع سند
        SDocDesc: "", // شرح سند
        NDebit: 0, // بدهکار
        NCredit: 0, // بستانکار
        SStatus: "", // وضعیت
        SOrgCode: "", // سازمان
      },
      checkShowDocRow: -1, // کنترل نمایش رکورد اطلاعات سند
      checkLoadData: true, // کنترل نمایش لطفا صبر نمایید
      SelectRowData: {}, // اطلاعات سطر در حال انتخاب
      SelectRowIndex: -1, // شماره سطر در حال انتخاب
      // آدرس تصویر لطفا صبر کنید
      waitImage: this.$store.getters.getImageUrl + "wait.gif",
      indexSearch: [],  // ایندکس آخرین سطر جستجو شده
      // فیلد نگهداری نام آخرین فیلد مرتب سازی شده
      lastSortFieldName: "",
    };
  },
  created() {
    this.GetTbDocInfoAllRecordFromServer();
  },
  computed: {
    // getTbDocInfoAllRecord() {
    //   this.TbDocInfoAllRecord = this.$store.getters.getTbDocInfoAllRecord;
    //   return this.TbDocInfoAllRecord;
    // },

    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      if (this.TbDocInfoAllRecord.length > 0) {
        // شماره شروع رکورد
        let startRowIndex = this.intPageNumber == 1 ? 1 : (parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) + 1);
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.TbDocInfoAllRecord.filter(function (item) {
          return (item.RowID >= startRowIndex && item.RowID < (parseInt(startRowIndex) + parseInt(intCountRowLocal)))
        });
        // نگهداری تعداد سطر در حال نمایش
        // جهت مدیریت نمایش پاپ آپ توضیحات کاربرد دارد
        this.intCountRowShow = ListTemplate.length;
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  methods: {
    // مشاهده تغییر در شماره صفحه
    // توسط کامپاننت صفحه بندی فراخوانی می شود
    ChangePageAllRow(value) {
      if (this.intPageNumber != value.pageNumber) {
        // اگر صفحه تغییر کرده بود به آخرین سطر برو
        this.scrollTable('LastAllRecordRow');
      }
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    // جابجایی به سطر جمع یا سربرگ
    scrollTable(objectID) {
      $("#" + objectID).scrollintoview({
        duration: 500,
      });
    },
    // نگهداری اطلاعات سطر انتخاب شده
    SaveRowSelect(RowData, RowIndex) {
      this.SelectRowData = RowData;
      this.SelectRowIndex = RowIndex;
    },
    // دریافت لیست حساب ها از مخزن
    async GetTbDocInfoAllRecordFromServer() {
      // let userData = await this.$store.getters.getUserData;
      // let NUserCode = userData.NUserCode;
      let token = await this.$store.getters.getUserData.token;
      let yearActive = await this.$store.getters.getYearActive;

      // دریافت لیست تمام رکوردهای تمام سندها از سرور
      await this.$store.dispatch(
        "GetTbDocInfoAllRecordFromServer",
        {
          NYear: yearActive,
          token: token,
        }
      );

      // نگهداری لیست دریافتی از سرور در مخزن محلی
      this.TbDocInfoAllRecord = await this.$store.getters.getTbDocInfoAllRecord;
      // اعلام پایان بازیابی اطلاعات از سرور
      this.EndGetDataFromServer = true;
    },
    // انتخاب سطر جهت نمایش سند
    async ShowDocRow(index, NDocNu, NId) {
      if (this.checkShowDocRow != index) {
        // نمایش تصویر لطفا صبر نمایید
        this.checkLoadData = true;
        // نمایش اطلاعات سند سطر جاری
        this.checkShowDocRow = index;
        // بازیابی اطلاعات سند توسط شماره سند
        this.docDataForShow = await this.$store.getters.getTbDocInfoByNId(NId);
        console.log(this.docDataForShow);
        // عدم نمایش تصویر لطفا صبر نمایید
        this.checkLoadData = false;
      } else {
        // عدم نمایش اطلاعات سند سطر جاری
        this.checkShowDocRow = -1;
        // عدم نمایش تصویر لطفا صبر نمایید
        this.checkLoadData = false;
      }
    },
    // جستجو در لیست تمام رکوردهای تمام اسناد
    // searchData(searchValue) {
    //   if (searchValue === "Search") {
    //     searchValue =
    //       $("#textDocInfoAllRecordSearch").val() != ""
    //         ? $("#textDocInfoAllRecordSearch").val()
    //         : "";
    //   }
    //   if (searchValue != "") {
    //     let index = this.TbDocInfoAllRecord.findIndex(
    //       (item) =>
    //         (item.NAccCode.toString().startsWith(searchValue) ||
    //           item.NDocNu.toString().startsWith(searchValue) ||
    //           item.SAccDesc.toString().includes(searchValue) ||
    //           item.NDebit.toString().startsWith(searchValue) ||
    //           item.NCredit.toString().startsWith(searchValue) ||
    //           item.NPerID.toString().startsWith(searchValue) ||
    //           item.NPerName.toString().includes(searchValue) ||
    //           item.NPerLastName.toString().includes(searchValue) ||
    //           item.NUsePlace.toString().startsWith(searchValue) ||
    //           item.SDesc.toString().includes(searchValue)
    //         ) &&
    //         this.indexSearch.indexOf(item.RowIndex) == -1
    //     );
    //     if (index != -1) {
    //       let RowIndex = this.TbDocInfoAllRecord[index].RowIndex;
    //       console.log(RowIndex);
    //       $("#" + RowIndex).scrollintoview({
    //         duration: 500,
    //         //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
    //       });
    //       // this.SelectRowID = NId;
    //       this.SaveRowSelect(this.TbDocInfoAllRecord[index], RowIndex);

    //       this.indexSearch.push(RowIndex);
    //     } else {
    //       // this.$store.dispatch("notify", {
    //       //   notText: "برای مقدار ( " + searchValue + " ) موردی پیدا نشد !",
    //       //   timeOut: 2500,
    //       // });
    //       this.indexSearch = [];
    //     }
    //   } else {
    //     this.$store.dispatch("notify", {
    //       notText: "مقداری برای جستجو درج نشده است !",
    //       timeOut: 2500,
    //     });
    //     this.indexSearch = [];
    //   }
    // },
    // جستجو در لیست اسناد
    // به روش فیلتر لیست
    async FilterDataInSearch(searchValue) {
      if (searchValue === "Search") {
        searchValue =
          $("#textDocInfoAllRecordSearch").val() != ""
            ? $("#textDocInfoAllRecordSearch").val()
            : "";
      }
      console.log(searchValue);
      if (searchValue != "") {
        let ListTemp = this.TbDocInfoAllRecord;
        console.log(ListTemp.length);
        ListTemp = ListTemp.filter(
          (item) =>
          (item.NId.toString().startsWith(searchValue) ||
            item.NYear.toString().startsWith(searchValue) ||
            item.NDocNu.toString().startsWith(searchValue) ||
            item.NAccCode.toString().startsWith(searchValue) ||
            item.SAccDesc.toString().includes(searchValue) ||
            item.NDebit.toString().startsWith(searchValue) ||
            item.NCredit.toString().startsWith(searchValue) ||
            item.NPerID.toString().startsWith(searchValue) ||
            item.NPerName.toString().includes(searchValue) ||
            item.NPerLastName.toString().includes(searchValue) ||
            item.NUsePlace.toString().startsWith(searchValue) ||
            item.SDesc.toString().includes(searchValue)
          )
        );
        ListTemp = await this.$store.dispatch('setRowIDForList', ListTemp);
        console.log(ListTemp);
        this.TbDocInfoAllRecord = ListTemp;
        // نگهداری موارد جستجوی قبلی
        this.ListSearchOld += (this.ListSearchOld != '' ? '/ ' : '') + searchValue;
      } else {
        // بازیابی اطلاعات از مخزن اصلی در مخزن محلی
        this.TbDocInfoAllRecord = await this.$store.getters.getTbDocInfoAllRecord;
        // تخلیه موارد جستجوی قبلی
        this.ListSearchOld = '';
      }
    },
    // مرتب سازی لیست بر اساس فیلد انتخابی
    sortDocRow(sortFieldName, sortFieldType) {
      // منبع مطلب
      // https://www.codegrepper.com/code-examples/javascript/frameworks/vue/Sort+numbers+in+javascript
      let docrow = this.TbDocInfoAllRecord;
      // بررسی وضعیت مرتب سازی صعودی یا نزولی
      if (sortFieldType === "") {
        if (this.lastSortFieldName === sortFieldName) {
          // فیلد تکراری است لذا مرتب سازی از بزرگ به کوچک
          sortFieldType = "desc";
          // تخلیه نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = "";
        } else {
          // فیلد جدید است لذا مرتب سازی از کوچک به بزرگ
          sortFieldType = "asc";
          // نگهداری نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = sortFieldName;
        }
      }

      // Set slice() to avoid to generate an infinite loop!
      // تکه تکه کردن() برای جلوگیری از تولید یک حلقه بی نهایت!
      if (docrow.length > 0) {
        if (sortFieldName === "NDocNu") {
          // شماره سند
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.TbDocInfoAllRecord = docrow.sort((a, b) => a.NDocNu - b.NDocNu);
          else this.TbDocInfoAllRecord = docrow.sort((a, b) => b.NDocNu - a.NDocNu);
        } else if (sortFieldName === "NYear") {
          // سال
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.TbDocInfoAllRecord = docrow.sort((a, b) => a.NYear - b.NYear);
          else this.TbDocInfoAllRecord = docrow.sort((a, b) => b.NYear - a.NYear);
        } else if (sortFieldName === "NAccCode") {
          // کد حساب
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.TbDocInfoAllRecord = docrow.sort((a, b) => a.NAccCode - b.NAccCode);
          else this.TbDocInfoAllRecord = docrow.sort((a, b) => b.NAccCode - a.NAccCode);
        } else if (sortFieldName === "SAccDesc") {
          // شرح حساب
          // مرتب سازی فیلد متنی
          this.TbDocInfoAllRecord = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SAccDesc;
              f2 = b.SAccDesc;
            } else {
              f1 = b.SAccDesc;
              f2 = a.SAccDesc;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "NDebit") {
          // بدهکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.TbDocInfoAllRecord = docrow.sort((a, b) => a.NDebit - b.NDebit);
          else this.TbDocInfoAllRecord = docrow.sort((a, b) => b.NDebit - a.NDebit);
        } else if (sortFieldName === "NCredit") {
          // بستانکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.TbDocInfoAllRecord = docrow.sort((a, b) => a.NCredit - b.NCredit);
          else
            this.TbDocInfoAllRecord = docrow.sort((a, b) => b.NCredit - a.NCredit);
        } else if (sortFieldName === "NPerLastName") {
          // طرف حساب
          // مرتب سازی فیلد متنی
          this.TbDocInfoAllRecord = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.NPerLastName;
              f2 = b.NPerLastName;
            } else {
              f1 = b.NPerLastName;
              f2 = a.NPerLastName;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "SDesc") {
          // مرکز هزینه
          // مرتب سازی فیلد متنی
          this.TbDocInfoAllRecord = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SDesc;
              f2 = b.SDesc;
            } else {
              f1 = b.SDesc;
              f2 = a.SDesc;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        }
      } else {
        return [];
      }
    },
    // مشاهده اطلاعات سند
    showDocInfoData(NId, NDocNu, BStatus) {
      // آیا سند از نوع دائم است ؟
      if (BStatus == true) {
        // سند از نوع دائم است و کاربر مجاز به ویرایش آن نمی باشد
        this.$store.dispatch("notify", {
          notText:
            "عدم ویرایش سند !\n شما مجاز به ویرایش سند از نوع دائم نمی باشید .",
          timeOut: 2500,
        });
      }
      // بارگیری اطلاعات سند جهت نمایش به کاربر
      var tabData = {
        tabContent: "AccDoc",
        NId: NId,
        NDocNu: NDocNu,
        tabID: 0,
        CheckChangeData: false,
        LocalData: false,
        readOnly: true,
      };
      this.$store.commit(
        "addTabList",
        tabData,
        this.$store.getters.getUserData.NUserCode
      );
      // ارسال شماره تب به رویداد تغییر تب فعال
      BusEvent.$emit("ChangeTabActive", tabData.tabID);
    },
    // کپی از سند جاری
    async CopyDocRowToNewDoc(nId, nDocNu) {
      var docData = await this.SearchNIdNDocNuInServer(nId, nDocNu);
      // ایجاد تب جدید با محتویات سند جاری
      this.addNewTab("AccDoc", true, docData);
    },
    // دریافت اطلاعات سند از سرور
    async SearchNIdNDocNuInServer(nId, nDocNu) {
      let userData = await this.$store.getters.getUserData;
      // let NUserCode = userData.NUserCode;
      let token = userData.token;
      let yearActive = await this.$store.getters.getYearActive;

      // دریافت اطلاعات سند با استفاده از کد سند از سرور
      var docData = await this.$store.dispatch(
        "GetTbDocInfoByNIdNDocNuFromServer",
        {
          NId: nId,
          NDocNu: nDocNu,
          NYear: yearActive,
          token: token,
        }
      );
      return docData;
    },
    // ایجاد تب جدید + کپی از سند جاری
    async addNewTab(tabType, localdata = false, tabdata = {}) {
      // دریافت کد برای تب جدید
      var newNDocNum = await this.$store.dispatch("createNewNDouNum");
      if (newNDocNum == 1) {
        newNDocNum = await this.$store.getters.getLargestNDocNuNId;
      }
      if (localdata == true) {
        var shamsi = require("shamsi-date-converter");
        var currentDate = shamsi.gregorianToJalali(new Date());
        tabdata.NDocNu = newNDocNum;
        tabdata.NId = 0;
        tabdata.SDocDate =
          currentDate[0] +
          "/" +
          currentDate[1].toString().padStart(2, "0") +
          "/" +
          currentDate[2].toString().padStart(2, "0");
        tabdata.NYear = currentDate[0];
      }
      // ایجاد اطلاعات تب جدید
      var tabData = {
        tabID: 0,
        tabContent: tabType,
        NId: 0,
        NDocNu: newNDocNum,
        CheckChangeData: false,
        LocalData: localdata,
        TabAccDocData: tabdata,
      };
      // ایجاد تب جدید
      this.$store.commit("addTabList", tabData);
      // ارسال شماره تب به رویداد تغییر تب فعال
      BusEvent.$emit("ChangeTabActive", tabData.tabID);
    },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}

.tdGradient2 {
  background: linear-gradient(rgba(233, 233, 233, 0.4),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 1));
}

.custom-cursor {
  /* cursor: url('/src/assets/images/sort-cursor.png'),auto; */
  cursor: ns-resize;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListDocInfo/Components/Tab2_ListHesab.vue